import gql from 'graphql-tag'

export const OC_PLUS_SUBSCRIPTION = gql`
    query orderchampPlusSubscription {
        viewer {
            account {
                orderchampPlus {
                    isActive
                    isTrial
                    startedAt
                    endsAt
                    paymentMethodDetails
                    subscription {
                        plan
                        name
                        price
                        cycleStartedAt
                        cycleEndsAt
                        cancellableAt
                        expiresAt
                        isCancellationScheduled
                        cancellationScheduledAt
                        paymentDetails
                        paymentMethod
                    }
                    invoices(first: 10) {
                        totalCount
                        results {
                            number
                            total
                            status
                            createdAt
                            url
                        }
                    }
                }
            }
        }
    }
`

export const OC_PLUS_SUBSCRIPTION_PLANS = gql`
    query orderchampPlusSubscriptionPlans {
        viewer {
            orderchampPlusPaymentMethods {
                name
                id
                logos
                description
            }
            orderchampPlusPlans {
                slug
                name
                amount
                discountedAmount
                description
                firstPaymentAmount
                taxPercentage
                taxAmount
                features {
                    slug
                    description
                    isAvailable
                }
                availableCoupon {
                    slug
                    amount
                    percentage
                    times
                }
            }
        }
    }
`

export const OC_PLUS_SUBSCRIPTION_PAYMENT_STATUS = gql`
    query orderchampPlusSubscriptionPaymentStatus {
        viewer {
            account {
                orderchampPlus {
                    isActive
                    paymentStatus {
                        state
                    }
                }
            }
        }
    }
`

export const SUBSCRIBE_MUTATION = gql`
    mutation orderchampPlusSubscribe($input: OrderchampPlusSubscribeInput!) {
        orderchampPlusSubscribe(input: $input) {
            url
            error
        }
    }
`

export const SUBSCRIPTION_CANCEL_MUTATION = gql`
    mutation orderchampPlusSubscriptionCancel {
        orderchampPlusCancel {
            success
        }
    }
`

export const SUBSCRIPTION_PAYMENT_PAID = gql`
    mutation orderchampPlusSubscriptionPaymentPaid {
        orderchampPlusSubscriptionPaymentPaid {
            state
            redirectUrl
        }
    }
`

export const UPDATE_PAYMENT_METHOD = gql`
    mutation orderchampPlusUpdatePaymentMethod {
        orderchampPlusUpdatePaymentMethod {
            url
            userErrors {
                message
                name
            }
        }
    }
`
